import { APIProvider, Map } from "@vis.gl/react-google-maps";
import TrackerLogin from "components/TrackerLogin";
import TrackerMarker from "components/TrackerMarker";
import { GOOGLE_API_KEY } from "constants/common";
import useTrackDriver from "hooks/tracker/useTrackDriver";
import { Alert } from "antd";

export default function TrackDriver() {
  const { data, isAuthenticated, handleCloseLogin, error } = useTrackDriver();

  return (
    <div className="w-full h-screen relative">
      {isAuthenticated ? (
        <>
          <APIProvider apiKey={GOOGLE_API_KEY}>
            <Map
              defaultZoom={14}
              defaultCenter={{
                lat: data?.latitude ?? 13.496494229233356,
                lng: data?.longitude ?? 39.47494624044569,
              }}
            >
              {data && <TrackerMarker data={data} />}
            </Map>
          </APIProvider>
          {error && (
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-10 w-96">
              <Alert
                message="No Location Data"
                description={error}
                type="warning"
                showIcon
                closable
              />
            </div>
          )}
          {data && !data.has_ongoing_trip && (
            <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-10 w-96">
              <Alert
                message="No Active Trip"
                description="The driver currently has no ongoing trip."
                type="info"
                showIcon
              />
            </div>
          )}
        </>
      ) : (
        <TrackerLogin handleClose={handleCloseLogin} />
      )}
    </div>
  );
}
